import React from "react";
import { DashboardPage } from "../../components/dashboard";

export default function Dashboard() {
  return <DashboardPage />;
}
